import { render, staticRenderFns } from "./CandidateLanguageCourse.vue?vue&type=template&id=164ffbdb&lang=pug&"
import script from "./CandidateLanguageCourse.vue?vue&type=script&lang=js&"
export * from "./CandidateLanguageCourse.vue?vue&type=script&lang=js&"
import style0 from "./CandidateLanguageCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
